import { inject, Injectable } from "@angular/core";
import { StorageApi } from "../Api/StorageApi";
import { StorageKeys } from "../Dto/StorageKeys";

/**
 * Effects service for storage operations.
 * Handles business logic for localStorage CRUD operations.
 */
@Injectable({ providedIn: "root" })
export class StorageEffects {
  private readonly storageApi = inject(StorageApi);

  /**
   * Get an item from localStorage.
   * Returns the value directly.
   */
  getItem(key: StorageKeys): string | null {
    return this.storageApi.getItem(key);
  }

  /**
   * Set an item in localStorage.
   */
  setItem<T>(key: StorageKeys, value: T): void {
    this.storageApi.setItem(key, value);
  }

  /**
   * Remove an item from localStorage.
   */
  removeItem(key: StorageKeys): void {
    this.storageApi.removeItem(key);
  }

  /**
   * Clear all items from localStorage.
   */
  clear(): void {
    this.storageApi.clear();
  }

  /**
   * Check if an item exists in localStorage.
   */
  hasItem(key: StorageKeys): boolean {
    return this.storageApi.hasItem(key);
  }

  /**
   * Get a parsed JSON value from localStorage.
   */
  getJsonItem<T>(key: StorageKeys): T | null {
    return this.storageApi.getJsonItem<T>(key);
  }

  /**
   * Set a JSON value in localStorage.
   */
  setJsonItem<T>(key: StorageKeys, value: T): void {
    this.storageApi.setJsonItem(key, value);
  }
}
